import { render, staticRenderFns } from "./productpricinglog.vue?vue&type=template&id=037fb99a&"
import script from "./productpricinglog.vue?vue&type=script&lang=js&"
export * from "./productpricinglog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports